import { render, staticRenderFns } from "./EditTaxCategoryModal.vue?vue&type=template&id=7e6f6318&"
import script from "./EditTaxCategoryModal.vue?vue&type=script&lang=js&"
export * from "./EditTaxCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports